// const breakPoint = 767;
// let resizeFlag   = false;
// let windowWidth  = window.innerWidth;
// let windowHeight = window.innerHeight;
// let windowWidthJ = $(window).width();



// ------------------------------------------------------------------------
// toggleHeader
// ----- SP
// ------------------------------------------------------------------------
const toggleHeader = () => {
  let headerFlag        = false;
  let stHeader  = document.getElementById('st-Header');
  let headerButtonOpen  = document.getElementById('st-Header_Button_Open');
  let headerNavigation  = document.getElementById('st-Header_Navigation');
  headerButtonOpen.addEventListener('click', () => {
    if(!headerFlag){
      headerNavigation.classList.add('st-Header_Navigation-Open');
      headerButtonOpen.classList.add('close');
      stHeader.classList.add('st-Header-Hidden');
      headerFlag = true;
    }else{
      headerNavigation.classList.remove('st-Header_Navigation-Open');
      headerButtonOpen.classList.remove('close');
      stHeader.classList.remove('st-Header-Hidden');
      headerFlag = false;
    }
  }, false);
  // headerButtonClose.addEventListener('click', () => {
  //   if(headerFlag){
  //   }
  // }, false);
};


// ------------------------------------------------------------------------
// toggleBox
// ----- BOTH
// ------------------------------------------------------------------------
const toggleBox = () => {
  let boxButton     = document.getElementsByClassName('st-Box_Button');
  let boxButtonText = document.getElementsByClassName('st-Box_Button_Text');
  let boxContents   = document.getElementsByClassName('st-Box_Contents');
  for(let i = 0; i < boxButton.length; i++){
    boxButton[i].addEventListener('click', () => {
      if(boxContents[i].classList.contains('st-Box_Contents-HiddenH') === true){
        boxButtonText[i].classList.remove('st-Box_Button_Text-Hidden');
        boxContents[i].classList.remove('st-Box_Contents-HiddenH');
        setTimeout(() => {
          boxContents[i].classList.remove('st-Box_Contents-HiddenO');
        }, 200);
      } else {
        boxButtonText[i].classList.add('st-Box_Button_Text-Hidden');
        boxContents[i].classList.add('st-Box_Contents-HiddenO');
        setTimeout(() => {
          boxContents[i].classList.add('st-Box_Contents-HiddenH');
        }, 200);
      }
    }, false);
  }
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 80;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  //ページ内リンク
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    var windwW       = $(window).width();
    if(windwW >= 768){
      linkAdjust += 60;
    }else{
      linkAdjust += 80;
    }
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });



};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {
  $("#st-footer_pagetop").on("click", function(){
    var linkSpeed    = 800;
    console.log("AAA");
    $("html, body").animate({scrollTop: 0}, linkSpeed, "swing");
    return false;
  });
};



export {
  toggleHeader,
  toggleBox,
  anchorLink,
  pageTop
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js